import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";

export const disciplineAPI = {
  getDisciplineSystem: async () => {
    const response = await apiClient.get("/teacher/discipline-system");
    return unwrapApiResponse(response);
  },
};
